import React, { Fragment, useContext } from 'react'
import PropTypes from 'prop-types'
import { IconButton, IntentsContext } from "../../../../common"
import { faThumbsDown, faThumbsUp, faQuestion } from '../../../../utilities'
import modules from './footer.module.scss'

const Footer = (props = {}) => {
    const { showFeedback, showHelp, handleInput, divider, ...rest } = props
    const { intents, Icons } = useContext(IntentsContext)
    const { negative, positive, help } = intents
    const type = 'feedback'

    return <Fragment>
        {divider && <hr />}
        <div className={modules.footer} {...rest}>
            {showFeedback && <div>
                <span id="helpful-feedback-label">Was this helpful?</span>
                <div className={modules.feedback} role="group" aria-labelledby="helpful-feedback-label">
                    <IconButton CustomIcon={Icons?.negative} aria-labelledby="helpful-feedback-disagree" outline onClick={() => handleInput(negative, { icon: faThumbsDown, type })} icon={faThumbsDown}>
                        <span id="helpful-feedback-disagree" className="sr-only">disagree</span>
                    </IconButton>
                    <IconButton CustomIcon={Icons?.positive} aria-labelledby="helpful-feedback-agree" outline onClick={() => handleInput(positive, { icon: faThumbsUp, type })} icon={faThumbsUp}>
                        <span id="helpful-feedback-agree" className="sr-only">agree</span>
                    </IconButton>
                </div>
            </div>}
            {showHelp && <IconButton CustomIcon={Icons?.help} aria-label="help" outline className={modules.help} icon={faQuestion} onClick={() => handleInput(help, { type: 'help' })} />}
        </div>
    </Fragment>
}

Footer.defaultProps = {
    showFeedback: true,
    showHelp: true,
    divider: true,
}

Footer.propTypes = {
    showFeedback: PropTypes.bool,
    showHelp: PropTypes.bool,
    divider: PropTypes.bool
}

export default Footer